import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

export default class PageNotFound extends React.Component {

    componentDidMount() {
        logUI("MBHWeb.UI.PageNotFound.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    render() {
        const { className } = this.props;
        const containerClass = "container-fluid body-content not-authorized-container" + (className ? " " + className : "");

        return (
            <div className={containerClass}>
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="section-error-container">
                            <div className="row">
                                <div className="col-12 align-self-center">
                                    <div className="row section-error__header">
                                        <div className="col-12">
                                            <div className="section-error__header--title">
                                                <span className="icon-important" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row section-error__body">
                                        <div className="col-12">
                                            <div className="section-error__body--message">
                                                Page not found.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}